import styled from 'styled-components';

import { PlanOption } from 'src/components/Prompts/PlanOption';

const baseFontSize = 16;

export const StyledHorizontalPrompt = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: ${baseFontSize}px;
  line-height: 1.1;

  .contracts {
    // Allow for amounts up to $999.99.
    --min-width: 5rem;

    all: unset;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(var(--min-width), 1fr));
    gap: 0.5em;
  }
`;

export const StyledHorizontalOption = styled(PlanOption)`
  list-style-type: none;
  box-sizing: border-box;
  font-size: ${baseFontSize}px;
  border-radius: 0.5rem;
  text-decoration: none;
  cursor: pointer;

  label {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    line-height: 1.5;
    padding: 0.5em;
    padding-inline: min(5vw, 1em);
    cursor: pointer;
  }

  .info {
    display: contents;
  }

  .text {
    font-style: normal;
    font-weight: 500;
    white-space: nowrap;
  }

  .price {
    font-style: normal;
    font-weight: 600;
  }
`;
